import React, { useState } from 'react';
import { Modal, Spinner } from '../../components/ui';
import { errMsg } from '../../utils/format';
import { useFetch } from '../../hooks/useFetch';
import api from '../../utils/api';

export default function AddReceivingModal({ onClose, onSaved }) {
  const { data: pos } = useFetch('/api/purchase-orders?status=sent');
  const [poId, setPoId] = useState('');
  const [poItems, setPoItems] = useState([]);
  const [receivingItems, setReceivingItems] = useState([]);
  const [notes, setNotes] = useState('');
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(false);

  const loadPO = async (id) => {
    if (!id) { setPoItems([]); setReceivingItems([]); return; }
    setPoId(id); setLoading(true);
    try {
      const { data } = await api.get(`/api/purchase-orders/${id}`);
      setPoItems(data.items || []);
      setReceivingItems((data.items||[]).map(item => ({
        poItemId: item.id,
        materialName: item.material_name,
        uom: item.unit_of_measure,
        orderedQty: item.quantity,
        receivedSoFar: item.quantity_received,
        quantityReceived: String(Math.max(0, item.quantity - item.quantity_received)),
        landedCost: '',
        notes: '',
      })));
    } catch(err) { alert(errMsg(err)); }
    finally { setLoading(false); }
  };

  const setRI = (idx,k,v) => setReceivingItems(i=>i.map((row,j)=>j===idx?{...row,[k]:v}:row));

  const save = async (e) => {
    e.preventDefault();
    if (!poId) { alert('Select a purchase order'); return; }
    setSaving(true);
    try {
      await api.post('/api/receiving', {
        poId: parseInt(poId), notes,
        items: receivingItems.filter(i=>parseFloat(i.quantityReceived)>0).map(i=>({
          poItemId: i.poItemId,
          quantityReceived: parseFloat(i.quantityReceived),
          landedCost: i.landedCost ? parseFloat(i.landedCost) : null,
          notes: i.notes,
        }))
      });
      onSaved('Receipt recorded successfully'); onClose();
    } catch(err) { alert(errMsg(err)); }
    finally { setSaving(false); }
  };

  return (
    <Modal title="Record Receipt" onClose={onClose} wide
      footer={<><button className="btn" onClick={onClose}>Cancel</button><button className="btn btn-primary" form="add-recv-form" type="submit" disabled={!poId}>{saving?'Saving…':'Record receipt'}</button></>}>
      <form id="add-recv-form" onSubmit={save}>
        <div className="form-group">
          <label>Purchase order *</label>
          <select required value={poId} onChange={e=>loadPO(e.target.value)}>
            <option value="">— Select sent PO —</option>
            {(pos?.orders||pos||[]).map(po=><option key={po.id} value={po.id}>{po.po_number} — {po.vendor_name}</option>)}
          </select>
        </div>
        {loading && <Spinner text="Loading PO items…" />}
        {receivingItems.length > 0 && (
          <>
            <div style={{ fontWeight:500, fontSize:13, marginBottom:8, marginTop:16 }}>Items received</div>
            {receivingItems.map((item,idx) => (
              <div key={idx} style={{ background:'var(--page-bg)', borderRadius:8, padding:12, marginBottom:8 }}>
                <div style={{ fontWeight:500, marginBottom:8 }}>{item.materialName} ({item.uom})</div>
                <div style={{ fontSize:12, color:'var(--text-tertiary)', marginBottom:8 }}>
                  Ordered: {item.orderedQty} | Already received: {item.receivedSoFar}
                </div>
                <div className="form-row">
                  <div className="form-group"><label>Qty receiving now</label><input type="number" step="0.001" min="0" value={item.quantityReceived} onChange={e=>setRI(idx,'quantityReceived',e.target.value)} /></div>
                  <div className="form-group"><label>Landed cost (total $, optional)</label><input type="number" step="0.01" min="0" placeholder="Leave blank to use PO price" value={item.landedCost} onChange={e=>setRI(idx,'landedCost',e.target.value)} /></div>
                </div>
              </div>
            ))}
          </>
        )}
        <div className="form-group" style={{ marginTop:8 }}><label>Notes</label><textarea value={notes} onChange={e=>setNotes(e.target.value)} /></div>
      </form>
    </Modal>
  );
}
